import { toggleModal } from "components/Stacker/actions/ModalActions"
import {
  reviewSelection,
  populateRefiners,
} from "components/Stacker/actions/StackerActions"
import AmuletProductList from "components/Stacker/components/Amulets/AmuletProductList/AmuletProductList"
import AmuletProductListHeader from "components/Stacker/components/Amulets/AmuletProductList/AmuletProductListHeader"
import AmuletStacker from "components/Stacker/components/Amulets/AmuletStacker/AmuletStacker"
import IntroCarousel from "components/Stacker/components/Amulets/IntroCarousel/IntroCarousel"
import NecklaceChooser from "components/Stacker/components/Amulets/NecklaceChooser/NecklaceChooser"
import AmountModal from "components/Stacker/components/Common/Modals/AmountModal"
import HelpModal from "components/Stacker/components/Common/Modals/HelpModal"
import ShareModal from "components/Stacker/components/Common/Modals/ShareModal"
import ProductList from "components/Stacker/components/ProductList/ProductList"
import ModalConfig from "components/Stacker/config/ModalConfig"
import SC from "components/Stacker/constants/StackerConstants"
import InfoBox from "../../Stacker/components/Common/InfoBox/InfoBox"
import {
  createCookie,
  getCookieValue,
} from "components/Stacker/lib/get-domain-cookie"
import queryString from "query-string"
import React, { useCallback, useState } from "react"
import App from "components/Stacker/components/App/App"
import "components/pages/AmuletStackerPage/AmuletStackerPage.scss"
import StackerConstants from "components/Stacker/constants/StackerConstants"
import { getDY_SR, setDY } from "stackerConfig"
import { useEffect } from "react"
import { shallowEqual, useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { useContext } from "react"
import { StackerContext } from "components/DYStackers/StackerContext"
import { useLocation } from "react-router"
import { useI18nContext } from "i18n/i18n-react"
import { shadowDOM } from "components/Stacker/utils/shadowDOM"
import { showProductInfoPanel } from "components/Stacker/actions/StackerActions"
import { selectQuickViewProduct } from "components/Stacker/actions/ProductDetailActions"

const searchNecklaces = {
  fq: `all_categories:"${
    getDY_SR("amulets").config.amuletStacker.necklaceCategory
  }"`,
  pageNumber: 0,
  pageSize: 40,
  q: "builder/necklace-builder",
  requestType: "search",
  search: "true",
  searchType: "category",
  sort: "low_price asc",
  metalvariant: "true",
}

function AmuletStackerPage() {
  const dispatch = useDispatch()
  const location = useLocation()
  const { LL } = useI18nContext()

  const stackerContext = useContext(StackerContext)
  const selectedAmount = useSelector((state) =>
    state.stacker.addedStack ? state.stacker.addedStack.length : 0
  )
  const selectedProduct = useSelector(
    (state) => state.amuletStacker.productInfo
  )

  const showInfoBox = selectedProduct.pid !== ""

  const isAppLoaded = useSelector((state) => state.stacker.isAppLoaded)

  const selectedChain = useSelector((state) => state.amuletStacker.chain)

  const addedStack = useSelector(
    (state) => state.stacker.addedStack,
    shallowEqual
  )

  const addedRetailerProducts = useSelector((state) => {
    return state.retailer.retailerProducts.filter(
      (_) =>
        selectedChain.chainVariantCode == _.baseProduct ||
        addedStack.some((a) => a.indexOf(_.baseProduct) != -1)
    )
  })

  // const pageSize = useSelector(
  //   (state) => state.search?.data?.pagination ? parseInt(state.search.data.pagination.pageSize) :  40
  // )
  const searchAmulets = useSelector((state) => {
    // const queryObj = queryString.parse(location.search)
    // const { thickness } = queryObj

    // if (thickness && parseFloat(thickness) > 0) {
    //   return {
    //     ...state.amuletStacker.search,
    //     fq: `bale_diameter: bale_diameter gte; ${state.amuletStacker.chain.thickness}`,
    //   }
    // }
    return state.amuletStacker.search
  }, shallowEqual)

  const productListExpanded = useSelector(
    (state) => state.amuletStacker.productListExpanded
  )
  const maxItems = useSelector((state) => state.amuletStacker.maxItems)
  const isStackerReady = useSelector((state) => state.stacker.isStackerReady)

  const getIsSelected = () => {
    const queryObj = queryString.parse(location.search, { decode: true })
    const { chainBaseProduct: queryChain } = queryObj
    return queryChain !== undefined
  }

  const [chainIsSelected, set_chainIsSelected] = useState(getIsSelected())
  const isVehicule = useSelector((state) => {
    const queryObj = queryString.parse(location.search, { decode: true })
    const {
      chainBaseProduct: queryChain,
      //chainVariantCode: queryChainVariant,
    } = queryObj
    return state.pdp && state.pdp[queryChain] && state.pdp[queryChain].meta
      ? state.pdp[queryChain].meta.isVehicle
      : false
  })

  const [isTChain, set_isTChain] = useState(false)

  const getSearchParams = () => {
    const queryObj = queryString.parse(location.search, { decode: true })
    const { chainBaseProduct: queryChain } = queryObj
    const isSelected = queryChain !== undefined
    return isSelected ? searchAmulets : searchNecklaces
  }

  const [searchParams, set_searchParams] = useState(getSearchParams())

  setDY("amulets")

  const main = shadowDOM.getElementById("stacker-root")
  main.classList.add("stacker-amulets-root")

  useEffect(() => {
    const queryObj = queryString.parse(location.search, { decode: true })
    const {
      chainBaseProduct: queryChain,
      chainVariantCode: queryChainVariant,
      thickness,
    } = queryObj
    const isSelected = queryChain !== undefined
    set_chainIsSelected(isSelected)
    //if (isSelected) {
    if (thickness && thickness > 0) {
      set_searchParams({
        ...searchAmulets,
        fq: `bale_diameter: bale_diameter gte; ${thickness}`,
      })
    } else {
      set_searchParams(isSelected ? searchAmulets : searchNecklaces)
    }
    set_isTChain(
      queryChain === StackerConstants.T_CHAIN &&
        queryChainVariant === StackerConstants.T_CHAIN_VARIANT
    )
  }, [location, searchAmulets])

  const onHelpClick = useCallback(
    (e) => {
      if (e) {
        e.preventDefault()
      }
      dispatch(toggleModal(ModalConfig.MODAL_STACKER_HELP, true))
    },
    [dispatch]
  )

  useEffect(() => {
    if (isAppLoaded) {
      const tutorialViewCookieValue = getCookieValue(SC.AMULET_TUTORIAL_COOKIE)
      const tutorialViewedCookie = {
        cookieName: SC.AMULET_TUTORIAL_COOKIE,
        cookieValue: true,
        cookiePath: true,
      }
      if (!tutorialViewCookieValue) {
        createCookie(tutorialViewedCookie)
        setTimeout(() => onHelpClick(null), 500)
      }
    }
  }, [isAppLoaded, onHelpClick])

  const doPopulateRefiners = useCallback(() => {
    const refinerData = {
      addedStack: addedStack,
      addedRetailerProducts: addedRetailerProducts,
    }

    dispatch(
      populateRefiners({
        chainVariantCode: selectedChain.chainVariantCode,
        data: refinerData,
      })
    )
  }, [addedStack, addedRetailerProducts, dispatch, selectedChain])

  const onReviewClick = useCallback(
    (e) => {
      stackerContext.getInstance().onSelectionReviewed()
      e.preventDefault()
      doPopulateRefiners()
      dispatch(reviewSelection(true))
    },
    [dispatch, doPopulateRefiners, stackerContext]
  )

  const onMoreInfoClick = useCallback(() => {
    dispatch(selectQuickViewProduct(selectedProduct.pid, selectedProduct.url))
    dispatch(toggleModal(ModalConfig.MODAL_QUICK_VIEW, true))
  }, [dispatch, selectedProduct.pid, selectedProduct.url])

  const onShareClick = useCallback(
    (e) => {
      e.preventDefault()
      dispatch(toggleModal(ModalConfig.MODAL_STACKER_SHARE, true))
    },
    [dispatch]
  )

  const onProductInfoCloseClick = useCallback(() => {
    dispatch(
      showProductInfoPanel({
        pid: "",
        url: "",
        title: "",
        description: { __html: "" },
      })
    )
  }, [dispatch])

  return (
    <App appType="amulets" searchParams={searchParams}>
      {!chainIsSelected && (
        <App.Chooser>
          <NecklaceChooser pageSize={40} onHelpClick={onHelpClick} />
          <HelpModal modalName={ModalConfig.MODAL_STACKER_HELP}>
            <IntroCarousel />
          </HelpModal>
        </App.Chooser>
      )}
      {chainIsSelected && showInfoBox && (
        <InfoBox
          description={selectedProduct.description}
          pid={selectedProduct.pid}
          title={selectedProduct.title}
          onMoreInfoClick={onMoreInfoClick}
          onProductInfoCloseClick={onProductInfoCloseClick}
        />
      )}
      {chainIsSelected && (
        <App.Stacker>
          <AmuletStacker
            onHelpClick={onHelpClick}
            onShareClick={onShareClick}
          />
          <HelpModal modalName={ModalConfig.MODAL_STACKER_HELP}>
            <IntroCarousel />
          </HelpModal>
          <ShareModal />
          <AmountModal />
        </App.Stacker>
      )}
      {chainIsSelected && (
        <App.ProductList>
          <ProductList
            columns={3}
            pageSize={searchAmulets.pageSize}
            productType="amulets"
          >
            <ProductList.Header>
              <AmuletProductListHeader
                expanded={productListExpanded}
                maxItems={isTChain ? { small: 2, large: 2 } : maxItems}
                selectedProductsAmt={selectedAmount}
              />
            </ProductList.Header>
            <ProductList.Body>
              <AmuletProductList
                maxItems={
                  isTChain ? 2 : isVehicule ? maxItems.small : maxItems.large
                }
              />
            </ProductList.Body>
            <ProductList.Footer>
              <button
                className="btn btn-blackrect d-block mx-auto w-100"
                disabled={selectedAmount === 0 || !isStackerReady}
                onClick={onReviewClick}
              >
                <span className="d-block d-lg-none">
                  {LL.amulets.nextStep()}
                </span>
                <span className="d-none d-lg-inline-block">
                  {LL.amulets.reviewSelection()}
                </span>
              </button>
            </ProductList.Footer>
          </ProductList>
        </App.ProductList>
      )}
    </App>
  )
}

export default AmuletStackerPage
